import {gql} from '@apollo/client';

export const LOGIN = gql`
    mutation Login($input: LoginRequestInput!) {
        crmLogin(input: $input) {
            email
            firstName
            lastName
            phoneNumber
            jwtToken
            sessionId
            tenantId
            tenantName
            userId
            refreshToken
            workspaceSlug
            boardSlug
            tenantSlug

            workspaceSettings {
                id
                uniqueId
                value {
                    value
                    selectedOption {
                        label
                        value
                        color
                        textColor
                    }
                    multiSelectedOptions {
                        label
                        value
                        color
                        textColor
                    }
                    booleanValue
                    integerValue
                }
            }
            tenantSettings {
                id
                uniqueId
                value {
                    value
                    selectedOption {
                        label
                        value
                        color
                        textColor
                    }
                    multiSelectedOptions {
                        label
                        value
                        color
                        textColor
                    }
                    booleanValue
                    integerValue
                }
            }
            boardSettings {
                id
                uniqueId
                value {
                    value
                    selectedOption {
                        label
                        value
                        color
                        textColor
                    }
                    multiSelectedOptions {
                        label
                        value
                        color
                        textColor
                    }
                    booleanValue
                    integerValue
                }
            }
        }
    }
`;
export const SIGN_UP = gql`
    mutation SignUp($input: AddUserViewModelInput!, $url: String!) {
        signUp(input: $input, url: $url) {
            id
            firstName
            lastName
            userName
            email
            phoneNumber
        }
    }
`;
export const RESET_PASSWORD = gql`
    mutation ResetPassword($input: ResetPasswordViewModelInput!) {
        resetPassword(input: $input) {
            statusCode
            message
            success
            data
        }
    }
`;

export const CONFIRM_EMAIL = gql`
    mutation ConfirmEmail($token: String!, $userId: UUID!, $password: String) {
        confirmEmail(token: $token, userId: $userId, password: $password) {
            statusCode
            message
            success
            data
        }
    }
`;

export const INITIATE_RESET_PASSWORD = gql`
    mutation InitiateResetPassword($email: String!, $frontEndRedirectUrl: String!) {
        initiateResetPassword(email: $email, frontEndRedirectUrl: $frontEndRedirectUrl) {
            statusCode
            message
            success
            data
        }
    }
`;

export const ADD_CLAIMS = gql`
    mutation AddClaims($includePreviousClaims: Boolean!, $input: [KeyValuePairInput!]!) {
        addClaims(input: $input, includePreviousClaims: $includePreviousClaims) {
            jwtToken
            expirey
        }
    }
`;

export const REFRESH_TOKEN = gql`
    mutation RefreshToken($input: String!) {
        refreshToken(token: $input) {
            jwtToken
            refreshToken
        }
    }
`;

export const GOOGLE_LOGIN = gql`
    mutation GoogleLogin {
        googleLogin {
            statusCode
            message
            success
            data
        }
    }
`;
